import { zod } from '@acme/core'
import dayjs from 'dayjs'
import { z } from 'zod'
import ApiService from '../api.service'
import { updateEmpresaSchema } from './empresas'

const dateString = z
    .date()
    .or(z.string())
    .transform(val => dayjs(val, 'YYYY-MM-DD', true).format('YYYY-MM-DD'))

const diaMes = z.coerce
    .number()
    .int()
    .min(1, 'O dia deve ser no mínimo 1')
    .max(31, 'O dia deve ser no máximo 31')

export const CreateTrocaInicioPontoSchema = zod.TrocaInicioPontoSchema.omit({
    id: true,
    createdAt: true,
}).extend({
    diaAnterior: diaMes,
    diaInicioPonto: diaMes,
    dataInicial: dateString,
    dataFinal: dateString,
    proximaDataInicial: dateString,
    proximaDataFinal: dateString,
})

export type TrocaInicioPonto = z.infer<typeof CreateTrocaInicioPontoSchema> & {
    id: number
    createdAt: string
}

export const updateDiaInicioPontoSchema = updateEmpresaSchema.pick({
    diaInicioPonto: true,
    id: true,
})

export type UpdateDiaInicioPontoInput = z.infer<
    typeof updateDiaInicioPontoSchema
>

export const upsertPeriodoPontoSchema = z.object({
    empresaId: z.coerce.number().int(),
    competencia: z.string().length(7, 'Competência inválida'),
    diaAnterior: diaMes,
    diaInicioPonto: diaMes,
    dataInicial: dateString,
    dataFinal: dateString,
})

export type UpsertPeriodoPontoInput = z.infer<typeof upsertPeriodoPontoSchema>

const dia = new ApiService<UpdateDiaInicioPontoInput>('troca-inicio-ponto/dia')

const service = new ApiService<TrocaInicioPonto>('troca-inicio-ponto')

export const trocaInicioPonto = Object.assign(service, { dia })
